import React, { useState } from 'react';
import { ReactComponent as DeleteContentIcon } from '../../assets/svg/DeleteContentIcon.svg';
import { ReactComponent as AngleUp } from '../../assets/svg/AngleUp.svg';
import MDEditor from '@uiw/react-md-editor';

function Paragraph({
	provided,
	paragraph,
	index,
	paragraphs,
	setParagraphs,
	paragraphTextError,
}: {
	provided: any;
	paragraph: any;
	index: number;
	paragraphs: any;
	setParagraphs: any;
	paragraphTextError: any;
}) {
	const [showParagraph, setShowParagraph] = useState(true);

	const _removeValue = (arr: any[], x: any) => {
		arr.splice(x, 1);
		return arr;
	};

	const handleTextChange = (value: any) => {
		let newList = JSON.parse(JSON.stringify(paragraphs));
		newList[index].text = value;
		setParagraphs(newList);
	};

	const removeParagraph = (index: number) => {
		let newList = [...paragraphs];
		newList = _removeValue(newList, index);
		let newReorderList = newList.map((item, index) => {
			return { ...item, order: index + 1 };
		});
		setParagraphs(newReorderList);
	};

	const changeType = (index: number) => {
		let newList = [...paragraphs];
		let newReorderList = newList.map((item: any, i: number) => {
			if (index === i) {
				return { ...item, type: item.type === 'TEXT' ? 'LIST' : 'TEXT' };
			} else {
				return item;
			}
		});
		setParagraphs(newReorderList);
	};

	return (
		<div className='mb-4' ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
			<div className='bg-lightBG rounded-xl px-4 py-2 border border-lightBG hover:border-primaryViolet' key={index} id={`question${index}`}>
				<div className=' '>
					<div
						className=' flex flex-row items-center '
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}
					>
						<p className='text-primaryViolet font-semibold text-[18px] leading-5 text-left flex-1'>Paragraph {paragraph?.order}</p>
						{showParagraph && (
							<div className='flex flex-row gap-5 flex-1 '>
								<div className={`flex flex-row items-center cursor-pointer `} onClick={() => {}}>
									<div className='border-[1.5px] border-primaryViolet rounded-full h-[18px] w-[18px] flex items-center justify-center' onClick={() => changeType(index)}>
										{paragraph.type === 'TEXT' && <div className='rounded-full h-[10px] w-[10px] bg-primaryViolet'></div>}
									</div>
									<label className='text-primaryViolet text-[16px] font-medium ml-[10px] cursor-pointer not-selectable'>TEXT</label>
								</div>
								<div className={`flex flex-row items-center cursor-pointer `} onClick={() => {}}>
									<div className='border-[1.5px] border-primaryViolet rounded-full h-[18px] w-[18px] flex items-center justify-center' onClick={() => changeType(index)}>
										{paragraph.type === 'LIST' && <div className='rounded-full h-[10px] w-[10px] bg-primaryViolet'></div>}
									</div>
									<label className='text-primaryViolet text-[16px] font-medium ml-[10px] cursor-pointer not-selectable'>LIST</label>
								</div>
							</div>
						)}
						<div className='flex flex-row pointer justify-between items-center' onClick={() => removeParagraph(index)}>
							<p className='text-redError text-[16px] font-medium mr-3'>Delete</p>
							<DeleteContentIcon fill='#FF747F' />
						</div>
						<button
							className={`flex items-center justify-center h-10 w-10 rounded-full ${showParagraph ? 'bg-white ' : 'bg-primaryViolet'} ml-[35px] transition cursor-pointer`}
							onClick={() => setShowParagraph((prev) => !prev)}
							style={{ transform: !showParagraph ? 'rotate(180deg)' : 'none' }}
						>
							<AngleUp color={showParagraph ? '#9392AD' : '#ffffff'} />
						</button>
					</div>
					{showParagraph && (
						<div className='mt-2'>
							<div className=''>
								<MDEditor data-color-mode='light' value={paragraph.text} onChange={(value: any) => handleTextChange(value)} preview='edit' />
							</div>

							<p className='text-redError font-medium text-[14px] leading-5 h-5 '>{paragraphTextError && paragraph.text === '' ? '* This field is required' : ''}</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default Paragraph;
